import { styled } from "@mui/material/styles";
import { Box, Typography, Backdrop } from "@mui/material";
import { fonts } from "../../../theme/theme";

export const ContentBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.gotham,
  fontSize: "50px",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.75rem",
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  fontSize: "22px",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "1.1rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));

export const FormBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5),
  width: "100%",
}));

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));
